import React from 'react';

import { Accordion } from "../../UI/Accordion";
import { AccordionSummary } from "../../UI/AccordionSummary";
import { AccordionDetails } from "../../UI/AccordionDetails";
import Grid from "@mui/material/Grid";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Typography } from "../../UI/Typography";
import {
  Lease } from "../../services/IntegrationApi";
import { AccDebugTableRow } from "./AccDebugTableRow";

interface Props {
  data: Lease[]
}

export const AccDebugTable: React.FC<Props> = ({ data }) => {

  return (<>
    <Grid container mb={1} pl={3}>
      <Grid item>
        <Typography variant="h4">Results</Typography>
      </Grid>
    </Grid>

    <Grid container pl={3}>
      <Grid item></Grid>

    {data.map((row, idx) => (
    <Accordion key={`${row.leases[0].leaseId}-${idx}`} defaultExpanded={idx === 0}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
        
      >
        <Grid container>
          <Grid item sm={3}>
            <Typography variant="subtitle1" fontWeight={500}>
              {row.firstName} {row.lastName}
            </Typography>
          </Grid>
          <Grid item alignContent="baseline" sm={6}>
            <Typography variant="subtitle1" fontWeight={100} >
              Resident Id: {row.id}
            </Typography>
          </Grid>
          <Grid item alignContent="baseline" sm={6}>
            <Typography variant="subtitle1" fontWeight={100} >
              Lease Number: {row.leases[0].leaseNumber}
            </Typography>
          </Grid>

        </Grid>
      </AccordionSummary>
      <AccordionDetails>
        <AccDebugTableRow lease={row} />
      </AccordionDetails>
    </Accordion>
    ))}
    </Grid>
    </>
  );
};
